import React from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardMedia, CardActionArea, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

import windowsImg from '../../../../assets/images/windows_11_pro.png';
import officeImg from '../../../../assets/images/ms_office_2024_pro.png';
import serverImg from '../../../../assets/images/windows_server_2025.png';
import otherServicesImg from '../../../../assets/images/ms_office_2024_hb.png';

const categories = [
  {
    title: 'Windows OS',
    image: windowsImg,
    grid: 6,
    path: '/shop',
  },
  {
    title: 'Microsoft Office',
    image: officeImg,
    grid: 6,
    path: '/shop',
  },
  {
    title: 'Windows Server',
    image: serverImg,
    grid: 6,
    path: '/shop',
  },
  {
    title: 'Other Services',
    image: otherServicesImg,
    grid: 6,
    path: '/shop',
  },
];

const CategoryShowcase = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ py: isMobile ? 4 : 6, background: 'linear-gradient(160deg, #D6EFFF 0%, #D6EFFF 50%, #D6EFFF 100%)' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            mb: 4,
            fontSize: isMobile ? '2.5rem' : '3.5rem',
            fontWeight: 800
          }}
        >
          Explore Our Categories
        </Typography>

        <Grid container spacing={isMobile ? 3 : 3}>
          {categories.map((cat, index) => (
            <Grid item xs={12} sm={cat.grid === 4 ? 6 : 12} md={cat.grid} key={index}>
              <motion.div
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <Card sx={{ borderRadius: 2, position: 'relative', height: isMobile ? 300 : 350, overflow: 'hidden' }}>
                  <CardActionArea href={cat.path} sx={{ height: '100%' }}>
                    <CardMedia
                      component="img"
                      image={cat.image}
                      alt={cat.title}
                      sx={{ height: '100%', objectFit: 'cover' }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.4)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#FFF',
                        p: 2,
                        transition: 'background-color 0.3s',
                        '&:hover': {
                          backgroundColor: 'rgba(14, 106, 218, 0.6)',
                        },
                      }}
                    >
                      <Typography
                        variant={isMobile ? "h5" : "h3"}
                        sx={{
                          fontWeight: 700,
                          textAlign: 'center',
                          color: 'white',
                          lineHeight: 1.2,
                          mb: isMobile ? 1 : 2
                        }}
                      >
                        {cat.title}
                      </Typography>
                      <Button
                        variant="outlined"
                        size={isMobile ? "medium" : "large"}
                        sx={{
                          mt: 2,
                          color: '#FFF',
                          borderColor: '#FFF',
                          fontSize: isMobile ? '0.9rem' : '1.1rem',
                          px: isMobile ? 3 : 5,
                          py: isMobile ? 1 : 1.5,
                          fontWeight: 600,
                          '&:hover': { backgroundColor: '#FFF', color: 'primary.main' },
                        }}
                      >
                        Explore Now
                      </Button>
                    </Box>
                  </CardActionArea>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CategoryShowcase;
